"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Search, TrendingUp, Target } from "lucide-react";
export default function ServiceDetails() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const steps = [{
    icon: Search,
    title: "Due Diligence",
    description: "Évaluation technologique et opérationnelle approfondie pour identifier les risques et opportunités."
  }, {
    icon: TrendingUp,
    title: "Planification de l'intégration",
    description: "Conception de feuilles de route stratégiques pour un alignement harmonieux des technologies et processus post-fusion."
  }, {
    icon: Target,
    title: "Capture de valeur",
    description: "Support à l'exécution pour accélérer les synergies et livrer des résultats mesurables."
  }];
  return <section ref={sectionRef} className="relative bg-background py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div className={`transition-all duration-700 ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="glass-effect p-8 lg:p-12 backdrop-blur-md bg-surface/80 border border-muted/30 shadow-medium hover:-translate-y-1 transition-all duration-300 ease-out">
              <CardContent className="space-y-6">
                <div>
                  <h2 className="text-3xl lg:text-4xl font-display font-bold text-foreground mb-4">
                    Fusions et Acquisitions & Création de Valeur
                  </h2>
                  <p className="text-muted-foreground text-lg leading-relaxed">
                    Nous accompagnons les dirigeants et investisseurs dans des opérations de M&A technologiques complexes, en apportant clarté stratégique et excellence opérationnelle.
                  </p>
                </div>

                <Separator className="bg-muted/20" />

                <div>
                  <h3 className="text-xl font-display font-semibold text-foreground mb-3">
                    Notre approche
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    De la due diligence à l'intégration post-fusion, nous assurons l'accélération de la valeur et une performance durable.
                  </p>
                </div>

                <div className="pt-4">
                  <p className="text-sm text-muted-foreground/80 italic">
                    Expertise en due diligence IT, intégration post-fusion, carve-outs et accélération de valeur.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="flex flex-col gap-6">
            {steps.map((step, i) => {
            const Icon = step.icon;
            const delay = i * 200;
            return <div key={i} data-index={i} className={`glass-effect p-6 backdrop-blur-md bg-surface/70 border border-muted/20 rounded-lg shadow-soft hover:-translate-y-1 hover:shadow-medium transition-all duration-300 ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: sectionVisible ? `${delay}ms` : "0ms"
            }}>
                  <div className="flex items-start gap-5">
                    <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 border border-primary/20 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-display font-semibold text-foreground mb-2">
                        {step.title}
                      </h4>
                      <p className="text-muted-foreground text-sm leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}